// src/screens/settings/pages/AccessoryModelsPage.jsx
import React from "react";
import { useParams, useLocation } from "react-router-dom";
import MasterDataListPage from "../MasterDataListPage";

export default function AccessoryModelsPage() {
  const { categoryId } = useParams();
  const location = useLocation();
  const parent = location.state?.parent; // ได้จาก nav(path, { state: { parent: it } })

  return (
    <MasterDataListPage
      title={parent?.name ? `แบรนด์ของ ${parent.name}` : "แบรนด์อุปกรณ์เสริม"}
      subtitle="แบรนด์"
      apiPath="/brands"
      fieldKey="name"
      createDefaultName="แบรนด์ใหม่"
      initialItems={[]}
      parentId={categoryId}
      queryParamsBuilder={(id) => ({
        filters: { accessory: { id: { $eq: id } } },
        sort: ["id:desc"],
        pagination: { pageSize: 200 },
      })}
      createPayloadBuilder={(value, id) => ({
        data: { name: value, sequence: 0, accessory: String(id) },
      })}
      updatePayloadBuilder={(value, currentItem, id) => ({
        data: {
          name: value,
          sequence: Number(currentItem?.sequence ?? 0) || 0,
          accessory: String(id),
        },
      })}
    />
  );
}
